export default function BanquesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('banques');
}

BanquesConfiguration.$inject = ['$translatePartialLoaderProvider'];
